<app-interlayer-card [currentList]="currentList"></app-interlayer-card>